import {Observable} from 'rxjs/Observable';
import {submitAddHomepageItemModal, closeAddHomepageItemModal, Types} from "./actions";

import {createResourceAction} from "resources/actions";
import * as ResourceApi from 'api/resources';
import {clone, getIndexOfObjectInArray, isNoU} from "utils/DBUtils";
import {resourcesSelector} from 'resources/selectors';

const homepageItemTypesToResources = {
  'HERO': ResourceApi.Types.HomepageHeroSection,
  'BREAK_GROUP': ResourceApi.Types.HomepageBreakGroup,
  'MESSAGE_BAR': ResourceApi.Types.HomepageMessageBar
};

const submitAddHomepageItemEpic = ($action, store) => $action.ofType(Types.SUBMIT_ADD_HOMEPAGE_ITEM_MODAL)
    .mergeMap((action) => {
        const state = store.getState();

        let homepageLayoutId = state.homepageLayout.currentSelectedHomepageLayoutId;
        let homepageColumnId = state.addHomepageItemReducer.columnId;
        let homepageSectionId = state.addHomepageItemReducer.sectionId;

        let data = action.data;

        let resourceIds = [
          {type: ResourceApi.Types.HomepageLayout, id: homepageLayoutId},
          {type: ResourceApi.Types.HomepageColumn, id: homepageColumnId},
          {type: ResourceApi.Types.HomepageSection, id: homepageSectionId}
        ];

        let homepage = resourcesSelector(state.resources)[state.homepageLayout.currentSelectedHomepageLayoutId];
        let homepageSectionIndex = getIndexOfObjectInArray(homepage.sections, homepageSectionId);
        let homepageSection = homepage['sections'][homepageSectionIndex];
        let homepageColumnIndex = getIndexOfObjectInArray(homepageSection.columns, homepageColumnId);

        let resourcePath = [];
        resourcePath.push('sections.' +  homepageSectionIndex);
        resourcePath.push('columns.' + homepageColumnIndex);

        let fieldPath = clone(resourcePath);
        fieldPath.push('items');

        return Observable.of(
          createResourceAction(  homepageItemTypesToResources[action.data.type],
                                        data,
                                        homepage,
                                        resourceIds,
                                        resourcePath,
                                        fieldPath),
          closeAddHomepageItemModal()
        );

    });

export default [
    submitAddHomepageItemEpic
]



// WEBPACK FOOTER //
// ./public/components/homepage-layouts/items/AddItemModal/epics.js